// import api from '@/utils/api';

const state = {
    balanceItems: [],
};

const getters = {
    balanceItems: (state) => state.balanceItems,
};

const actions = {
    updateBalanceItems({ commit }) {
        const options = [
            {
                value: '01',
                label: '資產',
                children: [
                    {
                        value: '0101',
                        label: '流動資產',
                        children: [
                            {
                                value: '010101',
                                label: '其他預付款',
                            },
                            {
                                value: '010102',
                                label: '暫付款',
                            },
                        ],
                    },
                    {
                        value: '0102',
                        label: '非流動資產',
                        children: [
                            {
                                value: '010201',
                                label: '保證金',
                            },
                            {
                                value: '010202',
                                label: '長期投資',
                            },
                            {
                                value: '010203',
                                label: '建物資產',
                            },
                            {
                                value: '010204',
                                label: '其他資產',
                            },
                        ],
                    },
                ],
            },
            {
                value: '02',
                label: '負債',
                children: [
                    {
                        value: '0201',
                        label: '流動負債',
                        children: [
                            {
                                value: '020201',
                                label: '保證金',
                            },
                            {
                                value: '020202',
                                label: '長期投資',
                            },
                            {
                                value: '020203',
                                label: '建物資產',
                            },
                            {
                                value: '020204',
                                label: '其他資產',
                            },
                        ],
                    },
                ],
            },
            {
                value: '03',
                label: '權益',
                children: [
                    {
                        value: '0301',
                        label: '銀行貸款',
                    },
                    {
                        value: '0302',
                        label: '其他信貸',
                    },
                ],
            },
        ];
        commit('update_balanceItems', options);
        /*
        return new Promise((resolve, reject) => {
            api({ url: 'Tool/GetIncomeStatementSettings', data: null, method: 'GET' })
                .then((resp) => {
                    commit('update_statementOptions', resp.data);
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
        */
    },
};

const mutations = {
    update_balanceItems(state, options) {
        state.balanceItems = options;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
